import { Stack } from "@mui/material";
import { type FC } from "react";
import "./PhoneNumberCell.scss";
import { VoicenterCallButton } from "../../components/voicenter/VoicenterCallButton";
import { formatPhoneNumber } from "../../generic-functions/format-phone-number";
import { openWhatsApp } from "../../generic-functions/open-whatsapp-message";

const PhoneNumberCell: FC<{
  phoneNumber: string;
  onCallInitiated?: () => void;
}> = ({ phoneNumber, onCallInitiated }) => {
  if (!phoneNumber) return null;

  const formatPhone = formatPhoneNumber(phoneNumber);

  return (
    <Stack flexDirection="row" alignItems="center" gap="0.5rem">
      <VoicenterCallButton
        phoneNumber={phoneNumber}
        onCallInitiated={onCallInitiated}
      />
      <button
        type="button"
        className="whatsapp-button"
        onClick={(e) => {
          e.stopPropagation();
          openWhatsApp(phoneNumber || "");
        }}
      >
        <img
          className="whatsapp-image"
          src="/whatsapp.png"
          alt="whatsapp-logo"
        />
      </button>
      <span title={formatPhone}>{formatPhone}</span>
    </Stack>
  );
};

export default PhoneNumberCell;
